jQuery(document).ready(function(){
    setTimeout(function() {
        console.log('Set time');
        var abc = jQuery('body').find('.related-products');
        abc.find('.product-grid').addClass('active');

        jQuery(".related-products .product-grid").slick({
            slidesToShow: 5,
            infinite: true,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 2
                      }
                  }
            ]
        });
    }, 1000);
});


// document.addEventListener('DOMContentLoaded', function(event) {
//   (function(){
//     const collapse = document.querySelectorAll('.productgrid--sidebar-menu .navmenu-item-parent span.collapse');
//     collapse.forEach(span => {
//       span.onclick = function() {
//         span.parentNode.classList.toggle('expanded');
//         span.nextElementSibling.classList.toggle('expanded');
//       }
//     });
//   })();
// });


$(document).ready(function () {
  function initFooterMenuToggle() {
    if ($(window).width() <= 1024) {
      $('.footer-menu h4').off('click').on('click', function () {
        const parent = $(this).parent('.footer-menu');
        const submenu = $(this).siblings('ul');

        if (parent.hasClass('active')) {
          parent.removeClass('active');
          submenu.slideUp(200);
        } else {
          parent.addClass('active');
          submenu.slideDown(200);
        }
      });
      $('.footer-menu').each(function () {
        if (!$(this).hasClass('active')) {
          $(this).find('ul').hide();
        }
      });

    } else {
      $('.footer-menu').removeClass('active');
      $('.footer-menu ul').show();
      $('.footer-menu h4').off('click');
    }
  }

  initFooterMenuToggle();

  $(window).resize(function () {
    initFooterMenuToggle();
  });
});





$(document).ready(function () {
  function initSlick() {
    if ($(window).width() < 768) { 
      if (!$('.highlights-banners').hasClass('slick-initialized')) { 
        $('.highlights-banners').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          arrows: false,
          dots: false
        });
      }
    } else { 
      if ($('.highlights-banners').hasClass('slick-initialized')) {
        $('.highlights-banners').slick('unslick'); 
      }
    }
  }

  initSlick();

  $(window).on('resize', function () {
    initSlick(); 
  });
});






jQuery(document).ready(function($) {
    // Initialize Slick Slider for the active tab
    function initializeSlick() {
        // Check if Slick is initialized and destroy it before reinitializing
        jQuery('.slider-tab:visible ').each(function() {
            if (jQuery(this).hasClass('slick-initialized')) {
                jQuery(this).slick('unslick');
            }
        });

        // Initialize Slick Slider for the visible tab
        jQuery('.slider-tab:visible ').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
                responsive: [
               {
                    breakpoint: 1024, // Adjust for smaller screens
                    settings: {
                        slidesToShow: 3, // Show 1 slide on smaller screens
                        centerMode: false // Disable center mode
                    }
                },
                {
                    breakpoint: 768, // Adjust for smaller screens
                    settings: {
                        slidesToShow: 2, // Show 1 slide on smaller screens
                        centerMode: false // Disable center mode
                    }
                },
                  {
                    breakpoint: 520, // Adjust for smaller screens
                    settings: {
                        slidesToShow: 1, // Show 1 slide on smaller screens
                        centerMode: false // Disable center mode
                    }
                }
            ]
        });
    }

    // Initialize Slick Slider on page load for the first tab (Featured products)
    initializeSlick();

    // Handle tab navigation click events
    jQuery('.tab-nav-item').click(function(e) {
        e.preventDefault();

        // Remove 'active' class from all tabs and add to the clicked one
        jQuery('.tab-nav-item').removeClass('active');
        jQuery(this).addClass('active');

        // Hide all slider tabs and show the selected one
        jQuery('.slider-tab').hide().removeClass('active');
        var tabId = jQuery(this).find('a').attr('href');
        jQuery(tabId).show().addClass('active');

        // Reinitialize Slick on the new active tab
        initializeSlick();
    });

    jQuery('.sliderss').slick({
             slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
           responsive: [
             {
                    breakpoint: 1081, // Adjust for smaller screens
                    settings: {
                        slidesToShow: 1, // Show 1 slide on smaller screens
                        centerMode: false // Disable center mode
                    }
                },
                {
                    breakpoint: 768, // Adjust for smaller screens
                    settings: {
                        slidesToShow: 1, // Show 1 slide on smaller screens
                        centerMode: false // Disable center mode
                    }
                }
            ]
    });
   document.getElementById('grid-view').addEventListener('click', function () {
    document.getElementById('ProductGridContainer').classList.add('grid-view');
    document.getElementById('ProductGridContainer').classList.remove('list-view');
    this.classList.add('active');
    document.getElementById('list-view').classList.remove('active');
  });

  document.getElementById('list-view').addEventListener('click', function () {
    document.getElementById('ProductGridContainer').classList.add('list-view');
    document.getElementById('ProductGridContainer').classList.remove('grid-view');
    this.classList.add('active');
    document.getElementById('grid-view').classList.remove('active');
  });



});
jQuery(document).ready(function() {
  jQuery('.tab-link').click(function() {
    var tabId = jQuery(this).data('tab');  // Get the data-tab attribute

    // Remove 'current' class from all tabs and contents
    jQuery('.tab-link').removeClass('current');
    jQuery('.tab-content').removeClass('current');

    // Add 'current' class to the clicked tab and corresponding content
    jQuery(this).addClass('current');
    jQuery('#' + tabId).addClass('current');
  });
});

// Show the Unit of sale on detial page 
jQuery(document).ready(function() {
  var checkedInput = jQuery('.option-value-input:checked');
  if (checkedInput.length > 0) {
      var selectedValue = checkedInput.val();
      jQuery('.custom-liquid .cstmcode').each(function() {
        var classes = jQuery(this).attr('class').split(' ');    
        if (classes.includes(selectedValue)) {
          jQuery(this).addClass('show');
        }
      });
  }
  jQuery('.option-value-input').on('click', function() {    
    var selectedValue = jQuery(this).val();
      jQuery('.custom-liquid .cstmcode').each(function() {
        var classes = jQuery(this).attr('class').split(' ');
        if (classes.includes(selectedValue)) {            
          jQuery(this).toggleClass('show');            
        } else {            
          jQuery(this).removeClass('show');            
        }
      });        
  });
});


function updateUnitOfSale(variantId) {
  var unitValue = $('#variant-metafields-wrapper .variant-metafield[data-variant-id="' + variantId + '"]').data('unitsale');
  if (unitValue) {
    $('#unit-of-sale-display').text('Unit of Sale: ' + unitValue);
  } else {
    $('#unit-of-sale-display').text('Unit of Sale: --');
  }
}

$(document).ready(function () {
  // Function to extract variant ID from URL
  function getVariantIdFromURL() {
    const url = new URL(window.location.href);
    return url.searchParams.get("variant");
  }

  // Initial load — show Unit of Sale for selected variant
  const initialVariantId = getVariantIdFromURL();
  if (initialVariantId) {
    updateUnitOfSale(initialVariantId);
  } else {
    // fallback: if no variant in URL, use first available variant
    const firstVariantId = $('#variant-metafields-wrapper .variant-metafield').first().data('variant-id');
    updateUnitOfSale(firstVariantId);
  }

  // On variant change (Shopify updates the variant URL automatically)
  $(document).on('change', '[name="id"]', function () {
    const selectedVariantId = $(this).val();
    updateUnitOfSale(selectedVariantId);
  });
});

$(document).ready(function () {

  // ==============================
  // 1. MAIN SIDEBAR TOGGLE
  // ==============================
  var $toggle = $('.productgrid--sidebar-title');
  var $content = $('.productgrid--sidebar-menu');

  if ($(window).width() <= 768) {
    $content.hide(); // hide on mobile
  }

  $toggle.off('click').on('click', function () {
    $content.slideToggle(200);
    $(this).toggleClass('active');
  });


  // ==============================
  // 2. COLLAPSE ALL SUBMENUS INITIALLY
  // ==============================
  if ($(window).width() <= 768) {
    $('.productgrid--sidebar-menu .navmenu-submenu').hide();
    $('.productgrid--sidebar-menu .navmenu-item-parent').removeClass('expanded');
  }


  // ==============================
  // 3. SUBMENU TOGGLE (CLICK ON + ICON)
  // ==============================
  $('.productgrid--sidebar-menu span.collapse').off('click').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var parent = $(this).closest('.navmenu-item-parent');
    var submenu = parent.children('.navmenu-submenu');

    if (submenu.length) {
      parent.toggleClass('expanded');
      submenu.slideToggle(200);
    }
  });

});

// ==============================
// POPUP FUNCTIONALITY
// ==============================
// jQuery(document).ready(function ($) {

//   var $popup = $('#custom-popup');
//   var $closeBtn = $('.popup-close');
//   var $overlay = $('.popup-overlay');

//   if ($popup.length) {

//     var hideUntil = localStorage.getItem("popupHideUntil");
//     var now = new Date().getTime();

//     function showPopup() {
//       $popup.removeClass('popup-hidden').addClass('popup-active');
//     }

//     function closePopup() {
//       $popup.addClass('popup-closing');

//       setTimeout(function () {
//         $popup.removeClass('popup-active popup-closing')
//               .addClass('popup-hidden');
//       }, 300); // match CSS transition time

//       // Set 5 hour timer
//       var fiveHoursLater = new Date().getTime() + (5 * 60 * 60 * 1000);
//       localStorage.setItem("popupHideUntil", fiveMinutesLater);
//     }

//     // Show popup if allowed
//     if (!hideUntil || now > hideUntil) {
//       setTimeout(showPopup, 2000);
//     }

//     // Close events
//     $closeBtn.on('click', closePopup);
//     $overlay.on('click', closePopup);

//   }

// });